import React from 'react';
import { cn } from '../../lib/utils';
import Masonry from 'react-masonry-css';
import './GoodThingsGrid.css';

interface GoodThingsGridProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'compact';
}

export const GoodThingsGrid: React.FC<GoodThingsGridProps> = ({ 
  children, 
  className,
  variant = 'default'
}) => {
  // Define breakpoints for responsive behavior
  const breakpointColumns = {
    default: 2,
    640: 1 // 1 column on mobile
  };
  
  // Get the gap size based on variant
  const gapSize = variant === 'compact' ? 'gap-4' : 'gap-6';
  const marginSize = variant === 'compact' ? 'mb-4' : 'mb-6';
  
  return (
    <Masonry
      breakpointCols={breakpointColumns}
      className={cn("flex w-full", gapSize, className)}
      columnClassName="masonry-grid-column"
    >
      {React.Children.map(children, (child) => (
        child && (
          <div className={cn("h-fit", marginSize)}>
            {child}
          </div>
        )
      ))}
    </Masonry>
  );
};
